module.exports = __webpack_public_path__ + "static/media/icon-mantra2.cb380571.png";